import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/root-reducer';
import { OnBehalfOfOrganizationAdminState } from './types';

const initialState: OnBehalfOfOrganizationAdminState = {
  onBehalfOfOrganizationAdmin: undefined,
};

const onBehalfOfOrganizationAdminSlice = createSlice({
  name: 'jobSeekerOnBehalfOfOrganizationAdmin',
  initialState,
  reducers: {
    setOnBehalfOfOrganizationAdmin: (state, action) => {
      state.onBehalfOfOrganizationAdmin = action.payload;
    },
    clearOnBehalfOfOrganizationAdmin: (state) => {
      state.onBehalfOfOrganizationAdmin = undefined;
    },
  },
});

export const selectJobSeekerOnBehalfOfOrganizationAdmin = (state: RootState) => state.jobSeekerOnBehalfOfOrganizationAdmin.onBehalfOfOrganizationAdmin;
export const selectJobSeekerOnBehalfOfOrganizationAdminId = (state: RootState) => state.jobSeekerOnBehalfOfOrganizationAdmin.onBehalfOfOrganizationAdmin?.value;

export const { setOnBehalfOfOrganizationAdmin, clearOnBehalfOfOrganizationAdmin } = onBehalfOfOrganizationAdminSlice.actions;
export const jobSeekerOnBehalfOfOrganizationAdminReducer = onBehalfOfOrganizationAdminSlice.reducer;
